import styled from 'styled-components'

export default styled.article`
  width: 800px;
  border-radius: 4px;
  background-color: ${ ({ theme }) => theme.colors.white };
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 50px;
  padding: 50px;

  section {
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: stretch;
    flex-wrap: nowrap;
    font-size: 18px;
  }

  h3 {
    margin-bottom: 30px;
    font-size: 20px;
  }

  .backButton {
    width: 20px;
    height: 20px;
    margin: 0 0 20px 0;
    display: block;
    cursor: pointer;
  }

  section {
    display: block;
    margin-bottom: 20px;

    & label {
      margin-left: 20px;
    }

    & label.title {
      margin-left: 20px;
      font-weight: bold;
    }

    & label.link {
      cursor: pointer;
    }
  }

  .images {
    flexDirection: 'row',
    alignSelf: 'stretch',
    justifyContent: 'center',
    paddingVertical: 4
  }

  .logos {
    width: 150px;
  }

  .icons {
    width: 50px;
    height: 50px;
  }
  
  @media screen and (max-width: 768px){
    width: 100%;
    margin: 0;
    overflow: auto;
    padding: 30px;

    .icons {
      width: 30px;
      height: 30px;
    }
  }
`
